export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/test.worker.772471c9.worker.js");
}
